var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 2.49984C5.83333 2.0396 6.20643 1.6665 6.66667 1.6665C7.1269 1.6665 7.5 2.0396 7.5 2.49984V3.33317H12.5V2.49984C12.5 2.0396 12.8731 1.6665 13.3333 1.6665C13.7936 1.6665 14.1667 2.0396 14.1667 2.49984V3.33317C16.0076 3.33317 17.5 4.82555 17.5 6.6665V14.9998C17.5 16.8408 16.0076 18.3332 14.1667 18.3332H5.83333C3.99238 18.3332 2.5 16.8408 2.5 14.9998V6.6665C2.5 4.82555 3.99238 3.33317 5.83333 3.33317V2.49984ZM12.5 4.99984V5.83317C12.5 6.29341 12.8731 6.6665 13.3333 6.6665C13.7936 6.6665 14.1667 6.29341 14.1667 5.83317V4.99984C15.0871 4.99984 15.8333 5.74603 15.8333 6.6665V8.33317H4.16667V6.6665C4.16667 5.74603 4.91286 4.99984 5.83333 4.99984V5.83317C5.83333 6.29341 6.20643 6.6665 6.66667 6.6665C7.1269 6.6665 7.5 6.29341 7.5 5.83317V4.99984H12.5ZM15.8333 9.99984H4.16667L4.16667 14.9998C4.16667 15.9203 4.91286 16.6665 5.83333 16.6665H14.1667C15.0871 16.6665 15.8333 15.9203 15.8333 14.9998V9.99984Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83398 12.4998C5.83398 12.0396 6.20708 11.6665 6.66732 11.6665H8.33398C8.79422 11.6665 9.16732 12.0396 9.16732 12.4998V14.1665C9.16732 14.6267 8.79422 14.9998 8.33398 14.9998H6.66732C6.20708 14.9998 5.83398 14.6267 5.83398 14.1665V12.4998Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEvent);
export default __webpack_public_path__ + "static/media/calendar-event.7beb946bd77efe1ab5dbe25387fc835a.svg";
export { ForwardRef as ReactComponent };